import { get, post, patch } from 'utils/api';

const BASE = '/fleet-reservations';

export const getFleetReservations = (data) => get(BASE, data);

export const getFleetReservation = (reservationCode) => get(`${BASE}/${reservationCode}`);

export const getFleetReservationFleetOptions = (params = {}) => get(`${BASE}/fleet-options`, params);

export const checkFleetReservationAvailability = (data) => post(`${BASE}/check-availability`, data);

export const createFleetReservation = (data) => post(BASE, data);

export const rescheduleFleetReservation = ({ reservationCode, ...data }) => patch(`${BASE}/${reservationCode}`, data);

export const cancelFleetReservation = ({ reservationCode, ...data }) => post(`${BASE}/${reservationCode}/cancel`, data);

export const fleetReservation = {
  getFleetReservations,
  getFleetReservation,
  getFleetReservationFleetOptions,
  checkFleetReservationAvailability,
  createFleetReservation,
  rescheduleFleetReservation,
  cancelFleetReservation,
};
